import { itemQueryKey } from './utils/use-get-item';

export const ORGANISATIONS = 'organisations';

export const organisationQueryKey = (organisationId?: string) =>
  itemQueryKey(ORGANISATIONS, organisationId);
